<template>
  <b-row class="m-0">
    <b-col class="p-0" v-if="templateArgs">
      <b-button :href="'/#/sales/edit/' + templateArgs.uidCode"
          v-if="(templateArgs.account.code === templateArgs.cs.toUpperCase().split(' - ')[0] || templateArgs.account.role.toUpperCase() === 'MANAGER' || templateArgs.account.role.toUpperCase() === 'FINANCE') && templateArgs.packing.length === 0 && templateArgs.shipping.length === 0"
          :variant="'outline-warning'" :size="'sm'" class="mb-1 col-12 p-0 v-btn">Edit Sales</b-button>
      <b-button v-if="!templateArgs.approval && (templateArgs.account.role.toUpperCase() === 'MANAGER' || templateArgs.account.role.toUpperCase() === 'FINANCE')"
          :variant="'outline-success'" :size="'sm'" class="mb-1 col-12 p-0" @click="approvalDialog">Approve</b-button>
      <b-button :to="'/#/inventory/packing/' + templateArgs.uidCode"
          v-if="templateArgs.shipping.length === 0 && templateArgs.approval && (templateArgs.account.role.toUpperCase() === 'MANAGER' || templateArgs.account.role.toUpperCase() === 'FINANCE' || templateArgs.account.role.toUpperCase() === 'WAREHOUSE')"
          :variant="'outline-info'" :size="'sm'" class="mb-1 col-12 p-0">Packing</b-button>
      <b-button :to="'/#/inventory/shipping/' + templateArgs.uidCode"
          v-if="templateArgs.packing.length > 0 && templateArgs.approval" :variant="'outline-primary'" :size="'sm'"
          class="mb-1 col-12 p-0">Shipping</b-button>
    </b-col>
  </b-row>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
      // data here
      templateArgs: null
    }
  },
  methods: {
    editSales () {
      this.templateArgs.vm.$router.push('/sales/edit/' + this.templateArgs.uidCode)
    },
    approvalTemplate (date, cs, type, product, customer, price, shipment, discount, payment) {
      var detail = '<div class="row m-0">'
      // cs
      detail += '<div class="col-6  p-0">Sales Person</div><div class="col-6  p-0 value-field">' +
                '<span class="text-capitalize">' + cs + ' (' + type.value.toUpperCase() + ')</span></strong></div>'
      // date
      detail += '<div class="col-6  p-0">Sales Date</div><div class="col-6  p-0 value-field"><strong>' + moment(date).format('DD MMMM YY') + '</strong></div>'
      detail += '<hr class="col-12"/>'
      // customer data
      detail += '<div class="col-12  p-0"><table style="width: 100%; border: none">'
      detail += '<tr><td class="px-1 py-2 text-capitalize" width="50%">Customer Name</td>' +
                '<td class="px-1 py-2 text-capitalize" style="border: none">' + customer.value.name.toLowerCase() + '</td>' +
                '</tr>'
      detail += '<tr><td class="px-1 py-2 text-capitalize">Phone Number</td>' +
                '<td class="px-1 py-2" style="border: none">' + customer.value.phone + '</td>' +
                '</tr>'
      var email = '-'
      if (customer.email !== null && typeof (customer.email) !== 'undefined') {
        email = customer.email
      }
      detail += '<tr><td class="px-1 py-2 text-capitalize">Email</td>' +
                '<td class="px-1 py-2" style="border: none">' + email.toLowerCase() + '</td>' +
                '</tr>'
      detail += '<tr><td class="px-1 py-2 text-capitalize">Address</td>' +
                '<td class="px-1 py-2 text-capitalize" style="border: none">' + customer.value.address.toLowerCase() + '</td>' +
                '</tr>'
      var notes = '-'
      if (notes != null && typeof (notes) !== 'undefined') {
        notes = customer.value.notes
      }
      detail += '<tr><td class="px-1 py-2 text-capitalize">Notes</td>' +
                '<td class="px-1 py-2 text-capitalize" style="border: none">' + notes + '</td>' +
                '</tr>'
      detail += '<tr><td colspan="2"><hr style="width: 100%" /></td></tr>'
      detail += '<tr><td class="px-1 py-2 text-capitalize">Bank Account</td>' +
                '<td class="px-1 py-2 text-capitalize" style="border: none">' + payment.account.toLowerCase() + '</td>' +
                '</tr>'
      detail += '<tr><td class="px-1 py-2 text-capitalize">Payment Time</td>' +
                '<td class="px-1 py-2 text-capitalize" style="border: none">' + moment(payment.time).format('DD-MM-YYYY HH:mm') + '</td>' +
                '</tr>'
      // detail += '</table></div>'
      // detail += '<hr class="col-12 "/>'
      // carts & prices
      // detail += '<div class="col-12  p-0"><table style="width: 100%; border: none">'
      var carts = product
      for (var i = 0; i < carts.length; i++) {
        var val = carts[i].qty * carts[i].product.price
        var valStr = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        detail += '<tr><td class="px-1 py-2 text-capitalize" width="50%">' + carts[i].product.name.toLowerCase() + ' <strong>' + carts[i].qty + '</strong> ' + carts[i].product.unit + '</td>' +
                  '<td class="px-1 py-2" style="border: none">' + valStr + '</td>' +
                  '</tr>'
      }
      var shippingCost = 0
      if (shipment !== null && typeof (shipment) !== 'undefined') {
        shippingCost = shipment
      }
      detail += '<tr><td class="px-1 py-2 text-capitalize">Shipping Cost</td>' +
                '<td class="px-1 py-2" style="border: none">IDR ' + shippingCost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + '</td>' +
                '</tr>'
      detail += '<tr><td class="px-1 py-2 text-capitalize">Total Discount</td>' +
                '<td class="px-1 py-2" style="border: none">IDR ' + (discount / 1).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + '</td>' +
                '</tr>'
      detail += '</table></div>'
      // total div
      detail += '<hr class="col-12"/>'
      detail += '<div class="col-6 offset-0 p-1 text-uppercase"><strong>Final Price</strong></div>' +
                '<div class="col-6 p-1"><strong>IDR ' + (price.value / 1).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + '</strong></div>'
      // ending div
      detail += '</div>'
      return detail
    },
    approvalDialog () {
      var vm = this
      window.$.confirm({
        theme: 'material',
        type: 'blue',
        title: 'APPROVAL CONFIRMATION',
        columnClass: 'col-12 col-md-8 col-md-offset-2',
        closeIcon: true,
        animateFromElement: false,
        animation: 'bottom',
        content: this.approvalTemplate(this.templateArgs.date, this.templateArgs.cs, this.templateArgs.type, this.templateArgs.product, this.templateArgs.customer, this.templateArgs.price, this.templateArgs.shipment, this.templateArgs.discount, this.templateArgs.payment),
        buttons: {
          cancel: {
            text: 'No. Don\'t approve yet!',
            btnClass: 'btn-outline-danger',
            action: function () {
              // do nothing
            }
          },
          confirm: {
            text: 'Yes. Approve sales!',
            btnClass: 'btn-outline-success',
            action: function () {
              vm.templateArgs.vm.axios.get('api/sales/logs/approve/' + vm.templateArgs.uidCode + '/')
                .then(
                  (response) => {
                    window.$.alert({
                      icon: 'fab faa-grav',
                      theme: 'modern',
                      animateFromElement: false,
                      animation: 'bottom',
                      title: 'Sales Approved',
                      type: 'success',
                      content: 'Sales Successfully Approved',
                      buttons: {
                        okay: {
                          text: 'Okay',
                          btnClass: 'btn-success',
                          action: function () {
                            vm.templateArgs.vm.$refs.datasource1.kendoWidget().read()
                          }
                        }
                      }
                    })
                  }
                )
                .catch(
                  (error) => {
                    console.log(error.response)
                    window.$.alert({
                      icon: 'fab faa-grav',
                      theme: 'modern',
                      title: 'Ooops!',
                      type: 'orange',
                      content: 'There seems to be a problem processing your request. Please try again later!'
                    })
                  }
                )
            }
          }
        }
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/SalesAction.vue